import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Lock, User } from "lucide-react";
import { login } from "@/lib/api";
import { LOGO_URL } from "@/data/navigationData";

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(formData.username, formData.password);
      localStorage.setItem("hh_token", res.data.token);
      localStorage.setItem("hh_user", JSON.stringify(res.data.user));
      toast.success("Connexion réussie !");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#004333] flex items-center justify-center p-4" data-testid="login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Happyhouse conciergerie" className="h-20 w-auto mx-auto mb-4 rounded-2xl border border-[#C9922A]/20 p-1.5" />
          <h1 className="font-display text-2xl text-white">Administration</h1>
          <p className="text-white/60 mt-2">Connectez-vous pour accéder au back-office</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 shadow-[0_8px_40px_rgba(0,0,0,0.15)]">
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Identifiant</label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                required
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:border-[#C9922A] focus:ring-2 focus:ring-[#C9922A]/10 outline-none transition-all"
                placeholder="Votre identifiant"
                autoComplete="username"
                data-testid="login-username"
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:border-[#C9922A] focus:ring-2 focus:ring-[#C9922A]/10 outline-none transition-all"
                placeholder="Votre mot de passe"
                autoComplete="current-password"
                data-testid="login-password"
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
